import {
  Form,
  FormGrid,
  Stack,
  type StackProps,
  Typography,
} from '@ace-clublabs/shared-component-library';
import type { ComponentProps } from 'react';

export const ContactForm: React.FC<ComponentProps<typeof Form>> = ({
  onSubmit,
  children,
  sx,
  ...props
}) => {
  return (
    <Form
      onSubmit={onSubmit}
      sx={{
        margin: 0,
        padding: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflowY: 'auto',
        ...sx,
      }}
      data-testid='contactInfoForm'
      {...props}
    >
      {children}
    </Form>
  );
};

export const ContactFormBody: React.FC<StackProps> = ({
  children,
  sx,
  ...props
}) => {
  return (
    <Stack
      direction='column'
      sx={{
        width: { lg: '65%', xs: '85%' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pt: '8px',
        flex: 1,
        pb: {
          xs: '80px',
          lg: '29px',
        },
        '& .MuiFormGrid-root': {
          width: '100%',
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Stack>
  );
};

interface ContactFormHeaderProps {
  header: string;
  subHeader?: string;
}

export const ContactFormHeader: React.FC<ContactFormHeaderProps> = ({
  header,
  subHeader,
}) => {
  return (
    <Stack
      direction='column'
      spacing={{
        xs: 0.5,
        md: 0,
      }}
      sx={{
        textAlign: {
          xs: 'left',
          md: 'center',
        },
      }}
    >
      <Typography data-testid='contactInfoHeader' variant='h4'>
        {header}
      </Typography>
      {subHeader && (
        <Typography
          variant='b1Regular'
          sx={{
            fontSize: {
              xs: '1.125rem',
            },
          }}
        >
          {subHeader}
        </Typography>
      )}
    </Stack>
  );
};

interface ContactFormGridProps {
  children: React.ReactNode;
}

export const ContactFormGrid: React.FC<ContactFormGridProps> = ({
  children,
}) => {
  return (
    <FormGrid
      sx={{
        width: '100%',
        marginTop: {
          xs: '20px',
          md: '32px',
        },
        textAlign: 'left',
        '& .MuiTextField-root': {
          alignItems: 'flex-start',
        },
        '& .MuiInputBase-input': {
          backgroundColor: 'rgba(255, 255, 255, 1)',
        },
        '& .MuiFormHelperText-root:has(.MuiBox-root:empty)': {
          display: 'none',
        },
      }}
    >
      {children}
    </FormGrid>
  );
};
